import { Message } from "primeng/primeng";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import "rxjs/add/operator/toPromise";
import { URLSearchParams } from "@angular/http";
import { MessageService } from "../../core/services/message.service";
import { BACKEND_API_URL } from '../../core/services/CusHttp';

export const LOGIN_URL = `${BACKEND_API_URL}login`;

export const REGISTER_URL = `${BACKEND_API_URL}register`;

export const CHECK_URL = `${BACKEND_API_URL}check`;
// 获取验证码
export const CODE_URL = `${BACKEND_API_URL}verify_code`;

export const PIC_CODE_URL = `${BACKEND_API_URL}getImageCode`;

@Injectable()
export class UserAuthService {
  constructor(private _hc: HttpClient, private _msg: MessageService) {
    // console.log(this._msg);
  }
  user;
  isLogined: boolean = false;

  // 用户登录
  login(username: string, password: string, ip: string) {
    const header = new HttpHeaders().set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    ).set('Authorization', 'aaaa');
    const params = new URLSearchParams();
    params.append("username", username);
    params.append("password", password);
    params.append("ip", ip);
    return this._hc
      .post(LOGIN_URL, params.toString(), { headers: header })
      // .map(data => data["data"])
      .toPromise()
      .then(resp => resp)
      .catch(error => this.handleError(error));
  }
  //获取验证码
  getCode(data) {
    const header = new HttpHeaders().set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );

    const params = new URLSearchParams();
    params.append("username", data.username);
    params.append("verifycode", data.piccode);
    params.append("token", data.token);
    return this._hc
      .post(CODE_URL, params.toString(), {headers: header})
      .toPromise()
      .then(resp => resp)
      .catch(error => this.handleError(error));
  }
  // register 用户注册
  register(
    username: string,
    password: string,
    repassword: string,
    sId: string,
    verifyCode: string,
    ip: string,
  ) {
    // console.log("register_info:::", username, password, email);

    const header = new HttpHeaders().set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    const params = new URLSearchParams();
    params.append("username", username);
    params.append("password", password);
    params.append("repassword", repassword);
    params.append("sId", sId);
    params.append("verifyCode", verifyCode);
    params.append("ip", ip);
    return this._hc
      .post(REGISTER_URL, params.toString(), { headers: header })
      // .map(data => data["data"])
      .toPromise()
      .then(resp => resp)
      // .then(resp => {
      //   resp && this._msg.success("注册成功！");
      //   setTimeout(() => {
      //     this._msg.clear();
      //   }, 2000);
      // })
      .catch(error => this.handleError(error));
  }
  private handleError(error) {
    // console.log("hahha",this);
    const msg = '请求失败';
    if (error.status === 400) {
      // console.log('请求参数正确');
    }
    if (error.status === 401) {
      // console.log('验证失败');
    }

    if (error.status === 403) {
      // console.error('已经经过身份验证的用户不允许访问指定的 API 末端');
    }

    if (error.status === 404) {
      // console.error('所请求的资源不存在');
    }

    if (error.status === 405) {
      // console.error('不被允许的方法。 请检查 Allow header 允许的HTTP方法');
    }

    if (error.status === 415) {
      // console.error('不支持的媒体类型。 所请求的内容类型或版本号是无效的。');
    }

    if (error.status === 422) {
      // console.log(error);
      if (typeof error.error === 'string') {
        let a = JSON.parse(error.error);
        a.map(abc => this._msg.error(abc.message));
      } else if (error.error.length) {
        error.error && error.error.map(abc => this._msg.error(abc.message));
      } else {
        this._msg.error('未知错误！');
      }
      setTimeout(() => {
        this._msg.clear();
      }, 2000);
      // console.error('数据验证失败 (例如，响应一个 POST 请求)。 请检查响应体内详细的错误消息。');
    }

    if (error.status === 429) {
      // console.error('请求过多。 由于限速请求被拒绝');
    }

    if (error.status === 500) {
      console.error('请求的服务器错误');
    }
    return { success: false, msg: msg };
  }

  // 检查登录状态
  checkStatus() {
    return this._hc
      .get(CHECK_URL, { withCredentials: true })
      .map(data => data["data"])
      .toPromise()
      .then(resp => {
        if (resp.user == null) {
          return false;
        } else {
          return true;
        }
      })
      .catch(error => {
        console.log("error", error);
      });
  }

  getPicCode() {
    return this._hc
      .get(PIC_CODE_URL, { withCredentials: true })
      .map(data => data["data"])
      .toPromise()
      .then(resp => resp)
      .catch(error => this.handleError(error));
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/user-auth/user-auth.service.ts